import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "~/components/shadcn/Tooltip";
import { cn } from "~/utils/fontsConfig";

const SimulcastLabelTooltip = () => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger>simulcast</TooltipTrigger>
                <TooltipContent>
                    <p className={cn("w-[200px] text-sm")}>
                        Create events in multiple cities at the same time.
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default SimulcastLabelTooltip;
